class ProviderSearch {
  constructor() {
    // Get a container to look up
    this.searchBox = document.getElementById("provider-search-v3");

    console.log("SEARCH BOX", this.searchBox);

    if (this.searchBox) {
      // Create warning message and put it before the submit button hidden
      const warningMessage = this.createWarningMessage();
      this.submitButton = document.getElementById("gform_submit_button_5");
      this.submitButton.insertAdjacentElement("afterend", warningMessage);

      this.claimLink = document.getElementById("claim-link");
      this.searchInput = document.getElementById("input_5_6");
      this.searchMode = "/wp-json/care/v1/provider_search?mode=provID";
      this.searchContainer = document.querySelector(".search-result-block");
      this.searchResults = document.getElementById("search-results-data");
      this.searchSpinner = document.getElementById("search-spinner");
      this.radioButtons = document.querySelectorAll('input[name="input_14"]');
      this.typingTimeout = null;
      this.spinnerVisible = false;
      this.isRadioYesSelected = false;
      this.canSubmit = true;

      // Get the variables because the gravity forms fields may change
      this.providerID = document.querySelector("#input_5_9");
      this.providerName = document.querySelector("#input_5_6");
      this.providerAddress = document.querySelector("#input_5_16");
      this.providerClaimed = document.querySelector("#input_5_10");
      this.inquiryEmailField = document.querySelector("#field_5_18");
      this.inquiryEmailInput = document.querySelector("#input_5_18");
      this.inquiryEmailButton = document.querySelector("#field_5_19");

      console.log("HEY THERE FORM 55");

      // Disable submit button initially
      this.triggerSubmit();

      // hide searchResults to begin
      this.searchContainer.style.display = "none";

      this.searchInput.addEventListener("keyup", e => {
        this.onSearchInputKeyUp(e);
      });

      // Listen for form reset
      const form = this.submitButton.closest("form");
      if (form) {
        form.addEventListener("reset", () => this.handleFormReset());
      }

      // add event listener to hide search results on "Escape" key press
      document.addEventListener("keyup", e => {
        if (e.key === "Escape") {
          this.hideSearchResults();
        }
      });

      // listen for radio button to be selected yes
      this.radioButtons.forEach(radio => {
        radio.addEventListener("change", e => {
          if (e.target.value === "Yes") {
            this.isRadioYesSelected = true;
            this.canSubmit = Boolean(this.providerID.value); // Only allow submit if provider is selected
            this.triggerSubmit();
          } else {
            this.isRadioYesSelected = false;
            this.canSubmit = true;
            this.triggerSubmit();
          }
        });
      });

      // Handle mouseenter event
      this.submitButton.addEventListener("mouseenter", e => {
        if (this.isRadioYesSelected && !this.providerID.value) {
          warningMessage.textContent = "You must select a provider from the list.";
          warningMessage.classList.remove("hidden");
        }
      });

      // Handle mouseleave event
      this.submitButton.addEventListener("mouseleave", e => {
        warningMessage.textContent = "";
        warningMessage.classList.add("hidden");
      });

      // add event listener to hide search results when user clicks outside the container
      document.addEventListener("click", e => {
        if (!this.searchContainer.contains(e.target)) {
          this.hideSearchResults();
        }
      });
    }
  }

  handleFormReset() {
    // Reset all relevant state
    this.isRadioYesSelected = false;
    this.canSubmit = false;
    this.searchInput.removeAttribute("readonly");

    // Clear all form values
    this.providerID.value = "";
    this.providerName.value = "";
    this.providerAddress.value = "";
    this.inquiryEmailInput.value = "";

    // Show inquiry email fields
    this.showInquiryEmail();

    // Remove clear button if it exists
    if (this.clearButton) {
      this.removeClearButton();
    }

    // Disable submit button
    this.triggerSubmit();

    // Hide search results
    this.hideSearchResults();
  }

  triggerSubmit() {
    if (!this.canSubmit) {
      this.submitButton.setAttribute("disabled", "disabled");
    } else {
      this.submitButton.removeAttribute("disabled");
    }
  }

  onSearchInputKeyUp(e) {
    // Clear any existing typing timeout.
    clearTimeout(this.typingTimeout);

    // Show the search block
    this.searchContainer.style.display = "block";

    // Show the loading message and spinner.
    this.searchSpinner.style.display = "block";
    this.searchResults.innerHTML = "<p>Loading...</p>";

    this.spinnerVisible = true;

    //Set a new typing timeout.
    this.typingTimeout = setTimeout(() => {
      // Make the axios call.
      this.getResults();
    }, 300);
  }

  async getResults() {
    try {
      const response = await axios.get(this.searchMode, {
        params: {
          query: this.searchInput.value
        }
      });
      this.displayResults(response.data);
    } catch (error) {
      this.displayNoResultsMessage();
    }
  }

  displayNoResultsMessage() {
    this.searchSpinner.style.display = "none";
    this.searchResults.innerHTML = "<p>No results found.</p>";
    this.searchResults.style.display = "block";
  }

  displayResults(data) {
    // Hide the loading message and spinner.
    this.searchResults.innerHTML = "";
    this.searchSpinner.style.display = "none";
    this.spinnerVisible = false;

    if (data.length === 0) {
      // If there are no results, display a message to the user.
      this.searchResults.innerHTML = "<p>No results found.</p>";
    } else {
      // Show the search results.
      this.searchResults.style.display = "block";

      // map through data and display results.
      data.map(result => {
        const resultHtml = `
          <div class="search-result-list cursor-pointer">
            <h3>${result.name}</h3>
            <p>${result.address}</p>
          </div>
        `;
        const resultElement = document.createElement("div");

        resultElement.innerHTML = resultHtml;
        this.searchResults.appendChild(resultElement);

        // add click event listener to result element
        resultElement.addEventListener("click", () => {
          this.canSubmit = true;
          this.triggerSubmit();

          // set input field values based on result properties
          this.providerID.value = result.id;
          this.providerName.value = result.name + " - " + result.address;
          this.providerAddress.value = result.address;

          this.searchInput.setAttribute("readonly", true);

          if (result.claimed === "1" && result.email !== "") {
            this.hideInquiryEmail();
          } else {
            this.showInquiryEmail();
          }

          this.createClearButton();

          // hide search results
          this.hideSearchResults();
        });
      });
    }
  }

  createClearButton() {
    // Create the clear button
    this.clearButton = document.createElement("button");
    this.clearButton.classList.add("clear-button", "text-primaryBlue", "my-2", "rounded-md", "py-1", "px-2");

    // Create the icon element
    const iconElement = document.createElement("i");
    iconElement.classList.add("fa-solid", "fa-arrow-rotate-left");

    // Append the icon element to the clear button
    this.clearButton.appendChild(iconElement);

    // Create the text node and append it to the clear button
    const buttonText = document.createTextNode(" Clear Provider Name");
    this.clearButton.appendChild(buttonText);

    // Insert the clear button after the search input
    this.searchInput.insertAdjacentElement("afterend", this.clearButton);

    // Event to clear the data and hide the clear button
    this.clearButton.addEventListener("click", e => {
      e.preventDefault();
      this.clearInputResults();
      this.removeClearButton();
    });
  }

  removeClearButton() {
    this.clearButton.remove();
  }

  clearInputResults() {
    this.showInquiryEmail();

    // Reset the search input and provider fields
    this.searchInput.value = "please enter in a provider name or address";
    this.providerID.value = "";
    this.providerName.value = "";
    this.providerAddress.value = "";
    this.searchInput.removeAttribute("readonly");

    // Reset submission state
    if (this.isRadioYesSelected) {
      this.canSubmit = false;
      this.triggerSubmit();
    }
  }

  hideInquiryEmail() {
    // add a value to this.inquiryEmailInput to pass validation
    this.inquiryEmailInput.value = "claimed@claimed.com";

    // hide inquiryEmailField and inquiryEmailButton
    this.inquiryEmailField.style.display = "none";
    this.inquiryEmailButton.style.display = "none";
  }

  showInquiryEmail() {
    // clear the value of this.inquiryEmailInput to pass validation
    this.inquiryEmailInput.value = "";

    // show inquiryEmailField and inquiryEmailButton
    this.inquiryEmailField.style.display = "block";
    this.inquiryEmailButton.style.display = "block";
  }

  hideSearchResults() {
    this.searchContainer.style.display = "none";
    this.searchResults.innerHTML = "";
  }

  createWarningMessage() {
    const warningMessage = document.createElement("div");
    warningMessage.id = "warning-message";
    warningMessage.classList.add("text-red-500", "hidden", "ml-2"); // Tailwind classes for styling
    return warningMessage;
  }
}

export default ProviderSearch;
